document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    if (event.target.matches("#trigger-lead-info")) {
      event.preventDefault(); //   let leadInfoButton = event.target;
      //	let leadInfoBackground = leadInfoButton.nextElementSibling;

      var leadInfoBackground = document.getElementById("leadTimeModal");
      var leadInfoModal = leadInfoBackground.firstElementChild;
      var leadInfoClose = leadInfoModal.firstElementChild;
      leadInfoBackground.classList.add("active"); //remove class hiding the modal background

      leadInfoClose.focus();
    }
  });
  document.addEventListener('keydown', closeLeadModal, false);

  function closeLeadModal(evt) {
    evt = evt || window.event;
    var isEscape = false;

    if ("key" in evt) {
      isEscape = evt.key === "Escape" || evt.key === "Esc";
    } else {
      isEscape = evt.key === 27;
    }

    if (isEscape) {
      var leadInfoModal = document.getElementById("leadTimeModal");

      if (leadInfoModal && leadInfoModal.classList.contains('active')) {
        leadInfoModal.classList.remove("active");
      }
    }
  }
}); // Tab key changes focus between anchors and close button.

document.addEventListener("keyup", function (e) {
  if (e.which == 9) {
    var currentModal = document.getElementById("leadTimeModal");

    if (currentModal) {
      var modalCloseButton = currentModal.querySelector("a");

      if (document.activeElement == modalCloseButton) {
        currentModal.querySelector("a").focus();
      } else {
        currentModal.querySelector(".close-modal").focus();
      }
    }
  }
}); // Close modal if user clicks outside.

document.addEventListener("click", function (e) {
  var currentModal = document.getElementById("leadTimeModal");

  if (currentModal && !e.target.closest(".modal") && currentModal.classList.contains('active')) {
    currentModal.classList.toggle("active");
  }
});